export const firebaseConfig = {
    apiKey: "AIzaSyBDcPzx56AcH7pX91FXgN5yOffRmXgy4fY",
    authDomain: "royal-fountain.firebaseapp.com",
    databaseURL: "https://royal-fountain-default-rtdb.firebaseio.com",
    projectId: "royal-fountain",
    storageBucket: "royal-fountain.appspot.com",
    messagingSenderId: "127744382048",
    appId: "1:127744382048:web:b8d1d99f287803f2359f05",
    measurementId: "G-MR4746TNHW"
};